
  export default {
    props: {
      floating: {
        type: Boolean,
        default: false,
      },
      separator: {
        type: String,
        default: "/",
      },
      light_text: {
        type: Boolean,
        default: false,
      },
      font_color: {
        type: String,
        default: ''
      }
    },
    data: () => ({
      crumbs: [],
    }),
    computed: {
      populateCrumbs ()
      {
        let result = [],
          path = "";
        for (let i = 0, len = this.crumbs; i < len.length; i++)
        {
          let slug = this.crumbs[i].split("-");
          if (slug.length > 0)
          {
            path += this.crumbs[i];
            path += "/";
            result.push({
              name: this.replacer(this.crumbs[i]),
              link: path,
            });
          }
        }
        return result;
      },
    },
    methods: {
      isNumber (n)
      {
        return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
      },
    },
    mounted ()
    {
      this.crumbs = this.$route.path.split("/");
      if (this.crumbs[this.crumbs.length - 1] == "")
      {
        this.crumbs.splice(this.crumbs.length - 1, 1);
      }
    },
  };
